<template>
  <div class="fixedSlideBar">
    <div class="sideBar">
      <ul>
        <li>
          <router-link to="/userinfo">
            <img src="../../assets/detail/info_img/yc01.png" />
          </router-link>
          <div class="tip">个人中心</div>
        </li>
        <li>
          <router-link to="/myAssets">
            <img src="../../assets/detail/info_img/yc02.png" />
          </router-link>
          <div class="tip">我的资产</div>
        </li>
        <li @click="showShopCart()" id="shopCart">
          <a href="javascript:;">
            <img src="../../assets/detail/info_img/yc03.png" />
          </a>
          <div class="tip chang1">我的购物车</div>
        </li>
        <li>
          <router-link to="/backshouye">
            <img src="../../assets/detail/info_img/yc05.png" />
          </router-link>
          <div class="tip chang1">我的优惠券</div>
        </li>
        <li>
          <router-link to="/systemnew">
            <img src="../../assets/detail/info_img/yc06.png" />
          </router-link>
          <div class="tip">我的消息</div>
        </li>

        <li>
          <a href="javascript:;">
            <img src="../../assets/detail/info_img/yc08.png" />
          </a>
          <div class="tip">意见反馈</div>
        </li>
        <li @click="goTop()">
          <a href="javascript:;">
            <img src="../../assets/detail/info_img/yc09.png" />
          </a>
        </li>
      </ul>
    </div>
    <div class="shopCartBox">
      <div class="head clearfix">
        <div class="head_left clearfix">
          <div class="sy-toux">
            <img :src="userImg" />
          </div>
          <div class="sy-userInfo">
            <p>
              <span>{{nickname}}</span>
              <img src="../../assets/detail/info_img/vip.png" />
            </p>
            <i>余额</i>
            <strong>￥{{yue}}元</strong>
          </div>
        </div>
        <div class="head_right clearfix">
          <p>
            <a href="javascript:;" title="关闭" @click="closeShopCart()">
              <img src="../../assets/detail/info_img/close.png" />
              <span>关闭</span>
            </a>
          </p>
        </div>
      </div>
      <div class="content">
        <div class="cateItems">
          <ul class="clearfix">
            <li class="current" id="allProducts" @click="showShopCart()">全部商品</li>
            <!-- <li @click="showweiCart()">未上传</li>
            <li @click="showyiCart()">已上传</li>-->
          </ul>
        </div>

        <div style="display: block;" class="item shangpin">
          <div class="btnGroups" v-if="JSON.stringify(userShopCarDate)!=='[]'">
            <button class="all-checked" @click="allCheck($event)">全选</button>
            <button class="batch-del" @click="deleteShopCar(deleteArr)">批量删除</button>
          </div>
          <div class="productBox">
            <template v-show="JSON.stringify(userShopCarDate)!='[]'">
              <div class="product-item" v-for="item in userShopCarDate" :key="item.id">
                <div class="title clearfix">
                  <div class="left">
                    <label>
                      <input type="checkbox" class="check" :id="item.id" @change="change($event)" />
                    </label>
                    <span class="time">{{item.createtime | dateFormat}}</span>
                  </div>
                  <div class="right">
                    <a href="javascript:;" title="删除此商品" @click="deleteShopCar(item.id)">
                      <img src="../../assets/detail/info_img/del.png" />
                      <span>删除</span>
                    </a>
                  </div>
                </div>
                <div class="shangpin-info clearfix">
                  <div class="sp-tup">
                    <img :src="item.product_img" style="width:100%" />
                  </div>
                  <div class="spIf">
                    <div class="clearfix sp-name">
                      <h3>{{item.product_name}}</h3>
                      <h4>
                        ￥
                        <span id="price">{{item.total_price}}</span> 元
                      </h4>
                    </div>
                    <div class="clearfix anniu">
                      <div class="left">
                        <p>{{item.title}}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="f">
                  <form name="theform">
                    <input style="display:none" type="radio" name="myradio" value="local_name" />
                    <input
                      style="display:none"
                      type="radio"
                      name="myradio"
                      value="random_name"
                      checked="true"
                    />
                    <input
                      style="display:none"
                      type="text"
                      id="dirname"
                      placeholder="如果不填，默认是上传到根目录"
                      :value="filePath"
                      size="50"
                    />
                  </form>
                  <div :id="item.id" class="contaniner">
                    <div>
                      <a
                        id="selectfiles"
                        href="javascript:void(0);"
                        :class="item.file_status==1 ? 'btn c' : 'btn' "
                      >{{item.file_status==1 ? '重新上传' : '选择文件'}}</a>
                    </div>
                  </div>
                  <!-- <h4>您所选择的文件列表：</h4> -->
                  <div class="ossfile"></div>
                </div>
              </div>
            </template>

            <div v-show="JSON.stringify(userShopCarDate)=='[]'">暂无数据</div>
          </div>
          <div class="zhifu">
            <p>
              已选
              <span>{{count}}</span>
              件， 共计：
              <span @click="getYue()">￥{{countPrice}}元</span>
            </p>
            <button @click="gozhifu()">去支付</button>
          </div>
        </div>
        <!-- <div class="item w-shangchuan">
          <div class="btnGroups" v-if="JSON.stringify(userShopCarDate)!=='[]'">
            <button class="all-checked" @click="allCheck($event)">全选</button>
            <button class="batch-del" @click="deleteShopCar(deleteArr)">批量删除</button>
          </div>
          <div class="productBox" style="height:816px">
            <template v-if="JSON.stringify(userShopCarDate)!=='[]'">
              <div class="product-item" v-for="item in userShopCarDate" :key="item.id">
                <div class="title clearfix">
                  <div class="left">
                    <label>
                      <input type="checkbox" class="check" :id="item.id" @change="change($event)" />
                    </label>
                    <span class="time">{{item.createtime | dateFormat}}</span>
                  </div>
                  <div class="right">
                    <a href="javascript:;" title="删除此商品" @click="deleteShopCar(item.id)">
                      <img src="../../assets/detail/info_img/del.png" />
                      <span>删除</span>
                    </a>
                  </div>
                </div>
                <div class="shangpin-info clearfix">
                  <div class="sp-tup">
                    <img :src="'http://open.yunshanyin.cn' + item.product_img" style="width:100%" />
                  </div>
                  <div class="spIf">
                    <div class="clearfix sp-name">
                      <h3>{{item.product_name}}</h3>
                      <h4>
                        ￥
                        <span id="price">{{item.total_price}}</span>元
                      </h4>
                    </div>
                    <div class="clearfix anniu">
                      <div class="left">
                        <p>{{item.title}}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <form name="theform">
                    <input style="display:none" type="radio" name="myradio" value="local_name" />
                    <input
                      style="display:none"
                      type="radio"
                      name="myradio"
                      value="random_name"
                      checked="true"
                    />
                    <input
                      style="display:none"
                      type="text"
                      id="dirname"
                      placeholder="如果不填，默认是上传到根目录"
                      size="50"
                    />
                  </form>
                  <div :id="item.id" class="contaniner">
                    <a
                      id="selectfiles"
                      href="javascript:void(0);"
                      :class="item.file_status==1 ? 'btn c' : 'btn' "
                    >{{item.file_status==1 ? '重新上传' : '选择文件'}}</a>
                  </div>
                  <div class="ossfile"></div>
                  <p>&nbsp;</p>
                </div>
              </div>
            </template>
            <div v-else>暂无数据</div>
          </div>
        </div>-->
        <!-- <div class="item y-shangchuan">
          <div class="btnGroups" v-if="JSON.stringify(WuserShopCarDate)!=='[]'">
            <button class="all-checked" @click="allCheck($event)">全选</button>
            <button class="batch-del" @click="deleteShopCar(deleteArr)">批量删除</button>
          </div>
          <div class="productBox">
            <template v-if="JSON.stringify(WuserShopCarDate)!=='[]'">
              <div class="product-item" v-for="item in WuserShopCarDate" :key="item.id">
                <div class="title clearfix">
                  <div class="left">
                    <label>
                      <input type="checkbox" class="check" :id="item.id" @change="change($event)" />
                    </label>
                    <span class="time">{{item.createtime | dateFormat}}</span>
                  </div>
                  <div class="right">
                    <a href="javascript:;" title="删除此商品" @click="deleteShopCar(item.id)">
                      <img src="../../assets/detail/info_img/del.png" />
                      <span>删除</span>
                    </a>
                  </div>
                </div>
                <div class="shangpin-info clearfix">
                  <div class="sp-tup">
                    <img :src="'http://open.yunshanyin.cn' + item.product_img" style="width:100%" />
                  </div>
                  <div class="spIf">
                    <div class="clearfix sp-name">
                      <h3>{{item.product_name}}</h3>
                      <h4>
                        ￥
                        <span id="price">{{item.total_price}}</span>元
                      </h4>
                    </div>
                    <div class="clearfix anniu">
                      <div class="left">
                        <p>{{item.title}}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <form name="theform">
                    <input style="display:none" type="radio" name="myradio" value="local_name" />
                    <input
                      style="display:none"
                      type="radio"
                      name="myradio"
                      value="random_name"
                      checked="true"
                    />
                    <input
                      style="display:none"
                      type="text"
                      id="dirname"
                      placeholder="如果不填，默认是上传到根目录"
                      size="50"
                    />
                  </form>
                  <div :id="item.id" class="contaniner">
                    <a
                      id="selectfiles"
                      href="javascript:void(0);"
                      :class="item.file_status==1 ? 'btn c' : 'btn' "
                    >{{item.file_status==1 ? '重新上传' : '选择文件'}}</a>
                  </div>
                  <div class="ossfile"></div>
                  <p>&nbsp;</p>
                </div>
              </div>
            </template>
            <div v-else>暂无数据</div>
          </div>
          <div class="zhifu">
            <p>
              已选
              <span>{{count}}</span>
              件， 共计：
              <i>￥{{countPrice}}元</i>
            </p>
            <button @click="gozhifu()">去支付</button>
          </div>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import 'distpicker'
export default {
  data() {
    return {
      // 用户头像
      userImg: '',
      // 用户名
      nickname: '',
      // 用户购物车
      userShopCarDate: [],
      token: window.localStorage.getItem('token'),
      // 图片url路径
      filrURL: '',
      flag: false,
      checked: false,
      deleteArr: [],
      // 选择件数
      count: 0,
      // 金额
      countPrice: 0,
      WuserShopCarDate: [],
      // 上传文件路径
      filePath: '',
      yue: 0,
      KFQQ: ''
    }
  },
  created() {
    if (window.localStorage.getItem('u')) {
      let u = JSON.parse(window.localStorage.getItem('u'))
      this.userImg = u.avatar
      this.nickname = u.nickname
      this.filePath =
        'uploads/' +
        u.mobile +
        '/' +
        new Date().toLocaleDateString().replace(/\//g, '-')
    }
    this.getYue()
  },
  methods: {
    // 用户余额
    async getYue() {
      if (window.localStorage.getItem('token')) {
        let param = new URLSearchParams()
        param.append('token', this.token)
        const { data: res } = await this.$http({
          method: 'post',
          url: 'api/mine/index',
          data: param
        })
        this.yue = res.data.money
      }
    },
    // 下单前验证
    async gozhifu() {
      if (this.count == 0) {
        this.$confirm('请选择要支付的商品', '提示')
        return
      }
      let items = $('.content .productBox').find('.check:checked')
      let checkarr = []
      let orderArr = []
      $.each(items, function(indexInArray, valueOfElement) {
        checkarr.push($(valueOfElement).prop('id'))
      })
      for (let i = 0; i < checkarr.length; i++) {
        for (let key in this.userShopCarDate) {
          if (checkarr[i] == this.userShopCarDate[key].id) {
            if (this.userShopCarDate[key].file_status == 1) {
              orderArr.push(this.userShopCarDate[key])
            } else if (this.userShopCarDate[key].file_status == 0) {
              this.$confirm(
                '您选择的商品中有未上传文件的商品，请选上传后再支付',
                '提示'
              )
              return
            }
          }
        }
      }
      this.$router.push('/paymentOrder')
    },
    // 计算选泽的件数，价格
    computedPrice() {
      setTimeout(() => {
        this.count = 0
        this.countPrice = 0
        let items = $('.content .productBox').find('.check:checked')
        this.count = items.length
        if (items.length > 0) {
          let price = 0
          $.each(items, (indexInArray, valueOfElement) => {
            price = $(valueOfElement)
              .parents('.title')
              .siblings('div')
              .find('#price')
              .text()
            this.countPrice += parseFloat(price)
          })
        } else {
          this.count = 0
          this.countPrice = 0
        }
      }, 500)
    },
    closeShopCart() {
      $('.shopCartBox').fadeOut()
      $('.sideBar').fadeIn()
    },
    // 全部选中
    allCheck(event) {
      this.count = 0
      this.countPrice = 0
      this.deleteArr = []
      this.checked = !this.checked
      let all_Check = $(event.currentTarget)
        .parents('.btnGroups')
        .siblings('.productBox')
        .find('.check')
      $(all_Check).prop('checked', this.checked)
      $.each(all_Check, (i, v) => {
        this.deleteArr.push($(v).attr('id'))
      })
      if (this.checked == false) {
        return (this.deleteArr = '')
      }
      this.deleteArr = this.deleteArr.join(',')
      this.computedPrice()
    },
    // 单选选中
    change(event) {
      this.deleteArr = []
      this.checked = false
      let checkBoxs = $(event.currentTarget)
        .parents('.productBox')
        .find('.check:checked')
      $.each(checkBoxs, (indexInArray, valueOfElement) => {
        this.deleteArr.push($(valueOfElement).attr('id'))
      })
      this.deleteArr = this.deleteArr.join(',')
      this.computedPrice()
    },
    // 点击全部、 显示购物车
    showShopCart() {
      if (!this.token) {
        this.$confirm('您需要先登陆才能使用购物车，是否立即去登陆?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.$router.push('/login')
          })
          .catch(() => {})
        return
      }
      $('.sideBar').hide()
      $('.shopCartBox').fadeIn()
      // 获取全部
      this.queryUserShopCart()
      this.computedPrice()
    },
    // 点击未上传
    showweiCart() {
      this.queryUserShopCart(2)
    },
    // 点击已上传
    showyiCart() {
      this.queryUserShopCart(1)
    },
    // 删除购物车商品
    async deleteShopCar(ids) {
      if (ids == '') {
        return this.$confirm('请先选择要删除的商品', '提示')
      }
      let param = new URLSearchParams()
      param.append('ids', ids)
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/car/delcar',
        data: param
      })
      if (res.code == 1) {
        this.deleteArr = ''
        this.$message.success('删除成功')
        this.queryUserShopCart()
        this.computedPrice()
      } else {
        this.$confirm('删除失败，未知原因', '错误')
      }
    },
    async queryUserShopCart(status = 0) {
      let all_Check = $('.productBox').find('.check')
      this.deleteArr = []
      $.each($('.content .check:checked'), (indexInArray, valueOfElement) => {
        this.deleteArr.push($(valueOfElement).attr('id'))
      })
      let param = new URLSearchParams()
      param.append('token', this.token)
      param.append('status', status)
      const { data: res } = await this.$http({
        method: 'post',
        url: '/api/car/index',
        data: param
      })
      if (status == 1) {
        res.data.length !== 0
          ? (this.WuserShopCarDate = res.data)
          : (this.WuserShopCarDate = [])
        return
      }
      res.data ? (this.userShopCarDate = res.data) : (this.userShopCarDate = [])
      // console.log(this.userShopCarDate)
    },
    goTop() {
      $('html,body').animate({
        scrollTop: 0
      })
    },
    async queryInfo() {
      const { data: res } = await this.$http.get('/api/index/apidata')
      this.KFQQ = res.data.kfqq
    }
  },
  mounted() {
    this.queryInfo()
    let height = $(window).height() - 280
    $('.productBox').height(height)
    const that = this
    $('.addcar').click(function() {
      setTimeout(() => {
        if (window.fXD == true) {
          that.showShopCart()
        }
      }, 350)
    })
    this.queryUserShopCart()
    $('.cateItems').on('click', 'ul li', function() {
      let index = $(this).index()
      $(this)
        .addClass('current')
        .siblings('li')
        .removeClass('current')
      $('.item')
        .eq(index + 1)
        .show()
        .siblings('.item')
        .hide()
    })
    $('.sideBar ul').on('mouseover mouseout', 'li', function(e) {
      if (e.type == 'mouseover') {
        $(this).addClass('curr')
        $(this)
          .children('.tip')
          .show()
      } else if (e.type == 'mouseout') {
        $(this).removeClass('curr')
        $(this)
          .children('.tip')
          .hide()
      }
    })
  }
}
</script>

<style lang="less" scoped>
#finishBox {
  width: 270px;
  height: 5px;
  background-color: #eee;
}

#finish {
  width: 100%;
  background-color: #a77c5a;
  background-size: 20px 20px;
  display: block;
  height: 5px;
}
.check {
  -webkit-appearance: none;
  appearance: none;
  outline: none;
  width: 15px;
  height: 15px;
  cursor: pointer;
  vertical-align: center;
  background: #fff;
  border: 1px solid #ccc;
  position: relative;
  margin-right: 5px;
}
.check:checked::after {
  content: '\2714';
  display: block;
  position: absolute;
  top: 1px;
  left: 0px;
  right: 0;
  bottom: 0;
  width: 18px;
  height: 18px;
  line-height: 10px;
  color: #a77c5a;
  font-size: 18px;
}
.item {
  display: none;
}
.sideBar {
  position: fixed;
  top: 345px;
  right: 5px;
  width: 35px;
  height: 332px;
  ul {
    li {
      background-color: #444;
      width: 36px;
      height: 36px;
      line-height: 36px;
      margin-bottom: 1px;
      text-align: center;
      cursor: pointer;
      position: relative;
      a {
        display: block;
        width: 100%;
        height: 100%;
        .qq {
          width: 19px;
          height: 20px;
        }
      }
      .tip {
        display: none;
        padding: 0 20px;
        position: absolute;
        left: -88px;
        top: 0px;
        height: 36px;
        line-height: 36px;
        background-color: #a77c5a;
        color: #fff;
        text-align: center;
      }
      .chang1 {
        padding-right: 10px;
      }
    }
    .curr {
      background-color: #a77c5a !important;
    }
  }
}
.shopCartBox {
  position: relative;
  display: none;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 25px;
  width: 290px;
  background: #fff;
  .head {
    height: 50px;
    padding: 15px 10px;
    width: 100%;
    background-color: #e8f4ee;
    .head_left {
      float: left;
      .sy-toux {
        float: left;
        margin-right: 10px;
        img {
          width: 50px;
        }
      }
      .sy-userInfo {
        padding-top: 5px;
        float: left;
        p {
          margin-bottom: 3px;
          img {
            margin-left: 5px;
          }
        }
        strong {
          font-size: 12px;
          color: #a77c5a;
        }
      }
    }
    .head_right {
      float: right;
      padding-top: 5px;
      padding-right: 10px;
      a {
        margin-right: 5px;
      }
      img {
        margin-right: 3px;
      }
      span {
        margin-right: 3px;
      }
      .dingdan {
        float: right;
        margin: 5px;
      }
    }
  }
  .content {
    width: 290px;
    background: #fff;
    padding: 0 12px;
    .cateItems {
      height: 40px;
      width: 100%;
      ul {
        li {
          box-sizing: border-box;
          float: left;
          height: 40px;
          line-height: 40px;
          text-align: center;
          width: 70px;
          color: #666;
          font-size: 12px;
          cursor: pointer;
        }
        .current {
          border-bottom: 2px solid #a77c5a;
          color: #a77c5a;
        }
      }
    }
    .item {
      .btnGroups {
        margin: 15px 0px 10px 0;
        .all-checked {
          padding: 8px 18px;
          color: #fff;
          background: #a77c5a;
          font-size: 14px;
          margin-right: 10px;
        }
        .batch-del {
          padding: 8px 18px;
          background-color: #e83030;
          color: #fff;
        }
      }
      .productBox {
        overflow-x: hidden;
      }
      .product-item {
        width: 290px;
        border: 1px solid #e7e7e7;
        padding-top: 5px;
        background-color: #fff;
        margin-bottom: 10px;
        .title {
          padding: 0 18px 0 10px;
          .left {
            float: left;
            .time {
              color: #999;
            }
          }
          .right {
            float: right;
            vertical-align: middle;
            span {
              margin-left: 3px;
              color: #999;
            }
          }
        }
        .shangpin-info {
          width: 290px;
          padding: 10px;
          background-color: #fff;
          .sp-tup {
            float: left;
            width: 60px;
            height: 60px;
          }
          .spIf {
            width: 205px;
            float: left;
            margin-left: 10px;
            .sp-name {
              padding-right: 15px;
              h3 {
                float: left;
              }
              h4 {
                float: right;
                font-size: 12px;
                color: #e83030;
                font-weight: 700;
              }
            }
            .anniu {
              margin-top: 5px;
              .left {
                float: left;
                p {
                  font-size: 12px;
                  color: #999;
                }
              }
              .right {
                padding-top: 15px;
                float: right;
                button {
                  width: 60px;
                  height: 20px;
                  color: #fff;
                  background-color: #4da5ff;
                  line-height: 20px;
                  text-align: center;
                  border-radius: 5px;
                  font-size: 12px;
                  margin-bottom: 5px;
                }
                .fixUpload {
                  display: none;
                }
              }
            }
          }
          .workURL {
            display: none;
            float: left;
            margin-top: 5px;
            span {
              color: #e83030;
            }
          }
        }
      }
      .zhifu {
        position: absolute;
        bottom: 0;

        p {
          text-align: center;
        }
        span {
          color: #e83030;
          font-size: 30px;
        }
        button {
          width: 295px;
          height: 45px;
          background-color: #a77c5a;
          font-size: 18px;
          color: #fff;
          text-align: center;
          line-height: 45px;
          border-radius: 5px;
          margin-top: 15px;
        }
      }
    }
    .y-shangchuan {
      .product-item {
        .shangpin-info {
          .anniu {
            .right {
              button {
                background: #ffa734 !important;
              }
            }
          }
        }
      }
    }
  }
}
</style>
